import { DeviceBreakpointsType } from '@kubit/web-ui-components/types/breakpoints';
export const layoutCardContainerCommonStyles = (FOUNDATIONS, FONT) => ({
    position: 'relative',
    display: 'grid',
    gap: FOUNDATIONS.spacing_300,
    z_index: 1,
    padding_top: FOUNDATIONS.spacing_300,
    padding_bottom: FOUNDATIONS.spacing_300,
    after: {
        content: '',
        position: 'absolute',
        top: `-${FOUNDATIONS.spacing_00}`,
        bottom: `-${FOUNDATIONS.spacing_00}`,
        right: `-${FOUNDATIONS.spacing_300}`,
        left: `-${FOUNDATIONS.spacing_300}`,
        border_radius: FOUNDATIONS.radius_250,
        z_index: -1,
        background_color: '#FFF',
    },
    [DeviceBreakpointsType.TABLET]: {
        display: 'block',
        gap: FOUNDATIONS.spacing_00,
        background_color: '#FFF',
        padding_top: FOUNDATIONS.spacing_00,
        padding_bottom: FOUNDATIONS.spacing_00,
        after: {
            display: 'none',
        },
    },
    [DeviceBreakpointsType.MOBILE]: {
        display: 'block',
        gap: FOUNDATIONS.spacing_00,
        background_color: '#FFF',
        padding_top: FOUNDATIONS.spacing_00,
        padding_bottom: FOUNDATIONS.spacing_00,
        after: {
            display: 'none',
        },
    },
});
export const layoutCardContainerFirstChildCommonStyles = (FOUNDATIONS, FONT) => ({
    padding_top: FOUNDATIONS.spacing_00,
    after: {
        top: `-${FOUNDATIONS.spacing_300}`,
    },
});
export const layoutCardContentContainerCommonStyles = (FOUNDATIONS, FONT) => ({
    display: 'block',
});
//# sourceMappingURL=commonStyles.js.map